angular
  .module('UserTrainingControllers')

  .directive('cfPartTraining', function() {
    return {
      restrict: 'E',
      scope: {
        currentPart: '='
      },
      templateUrl:
        '/ng1/www/modules/user/practice/training/html/part_training.html',
      controller: [
        '$scope',
        '$mdDialog',
        'EXAM',
        function($scope, $mdDialog, EXAM) {
          $scope.exam = EXAM;

          // Call dialog to change parts
          $scope.showConfirm = function(ev) {
            //$scope.currentPart;
            $scope.optionsPartToUrl = {};

            for (var i = 0; i < $scope.currentPart.length; i++) {
              var part = $scope.currentPart[i];
              $scope.optionsPartToUrl[part] = true;
            }

            $mdDialog.show({
              clickOutsideToClose: true,
              preserveScope: true,
              parent: angular.element(document.body),
              templateUrl:
                '/ng1/www/modules/user/practice/training/html/dialog_options.html',
              targetEvent: ev,
              locals: {
                optionsPartToUrl: $scope.optionsPartToUrl
              },
              controller: [
                'scope',
                '$mdDialog',
                'optionsPartToUrl',
                '$mdToast',
                '$location',
                'exam',
                'EXAM',
                '$translate',
                function DialogController(
                  scope,
                  $mdDialog,
                  optionsPartToUrl,
                  $mdToast,
                  $location,
                  exam,
                  EXAM,
                  $translate
                ) {
                  scope.theme = EXAM;
                  scope.optionsPartToUrl = optionsPartToUrl;
                  scope.exam = exam;
                  scope.sections = exam.sections;

                  scope.hide = function() {
                    $mdDialog.hide();
                  };

                  scope.confirm = function() {
                    $mdDialog.hide();

                    var toUrl = [];

                    // Need to transform object in array for url
                    angular.forEach(optionsPartToUrl, function(value, key) {
                      if (value) {
                        toUrl.push(key);
                      }
                    });

                    $location.search('part', toUrl);
                    $scope.currentPart = toUrl;

                    $mdToast.show(
                      $mdToast
                        .simple()
                        .textContent(
                          $translate.instant(['toasts.modifications_updated'])[
                            'toasts.modifications_updated'
                          ]
                        )
                        .position('bottom right')
                        .hideDelay(3000)
                    );
                  };
                }
              ]
            });
          };
        }
      ]
    };
  })

  // need to isolate scope
  .directive('cfLessonsToolbar', function() {
    return {
      restrict: 'E',
      templateUrl:
        '/ng1/www/modules/user/practice/training/html/lessons_toolbar.html',
      controller: [
        '$scope',
        'lesson',
        function($scope, lesson) {
          $scope.showLessons = function(ev) {
            lesson.dialogList(ev);
          };
        }
      ]
    };
  })

  .directive('cfOverlayPay', [
    'EXAM',
    function(EXAM) {
      return {
        restrict: 'E',
        template:
          '\
        <a ng-href="{{(main.exam === \'bright\') ? \'javaScript:void(0);\' : \'#!payment/form\'}}" class="cf-overlay-pay animated no-decoration" layout="column" layout-align="start center">\
          <img height="120" src="/ng1/www/img/index/chrono-3.svg"></p>\
          <md-button ng-if="main.exam !== \'bright\'" class="md-raised">Choisir un abonnement</md-button>\
        </a>\
      '
      };
    }
  ]);
